import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@zapier/zinnia-icons';
import { Colors, Typography } from '@zapier/design-system';

import { mediaQueries } from '@zapier/identity-utils';

type FeatureItemProps = {
  children: ReactNode;
  content?: string;
};

const listItemStyles = css`
  align-items: center;
  display: flex;
  gap: 8px;
  text-align: start;

  [class*='formCheckCircle'] {
    display: none;
  }

  ${mediaQueries.tablet} {
    [class*='formCheckCircle'] {
      display: inherit;
    }
  }

  ${mediaQueries.desktop} {
    gap: 15px;
  }
`;

const iconContainer = css`
  display: inline-block;
  height: 20px;
  width: 20px;

  ${mediaQueries.tablet} {
    display: none;
  }

  &:first-of-type {
    display: none;

    ${mediaQueries.tablet} {
      display: inline-block;
    }
  }
`;

const listItemTextStyles = css`
  ${Typography.SmallPrint1}
  color: ${Colors.GrayWarm9};

  ${mediaQueries.tablet} {
    ${Typography.Body1}
    color: ${Colors.GrayWarm9};
  }
  ${mediaQueries.desktop} {
    ${Typography.Body1}
    color: ${Colors.GrayWarm9};
    line-height: 1.5rem;
  }
`;

export function FeatureItem({ children, content }: FeatureItemProps) {
  return (
    <li css={[listItemStyles]}>
      <div css={iconContainer}>
        <Icon
          color={'StatusSuccessStronger'}
          name="formCheckCircle"
          size={20}
        />
      </div>
      <div css={iconContainer}>
        <Icon color={'GrayWarm9'} name="formCheck" size={20} />
      </div>
      <span css={listItemTextStyles}>{content || children}</span>
    </li>
  );
}
